<template lang="html">
  <div class="surroundings">
    <common-header></common-header>
    <list-kv :kvArray="kvItems"></list-kv>
    <surroundings-container ></surroundings-container>
    <common-footer></common-footer>
  </div>
</template>

<script>
	//组件
	import commonHeader from '../../components/common/commonHeader'
	import commonFooter from '../../components/common/commonFooter'
	import listKv from '../../components/common/listKv'
	import surroundingsContainer from '../../components/surroundings/surroundingsContainer'
	//接口
	import Server from '../../server/server.js'
	export default {
	  	data(){
		  	return{
		  		kvItems:[],
		  		surroundingsItems:[],
		  		startIndex:0,
		  		endIndex:9,
		  		typeCode:'9903002',
		  		page:0,
		  	}
	  	},
	  	components:{
	  		commonHeader,
	  		commonFooter,
	  		listKv,
	  		surroundingsContainer
	  	},
	  	created(){
	  		//KV数据
	  		Server.listConfig('surroundingsBanner').then((result)=>{
	  			if(result.code == '0'){
	  				this.kvItems = result.msg.types;
	  				// console.log(this.kvItems);
	  			}
	  		})
	  	}
	}
</script>

<style lang="less" scoped>
	.surroundings{
		// padding-bottom:250px;
	}
</style>


// WEBPACK FOOTER //
// src/container/surroundingsPage/surroundings.vue